import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box, Button, TextField, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import MainCard from '../../ui-component/cards/MainCard';
import { gridSpacing } from '../../store/constant';
import axiosInstance from '../../axiosInstance';
import configData from '../../config';
import { useSelector } from "react-redux";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';

function ManageRecords() {
    const [records, setRecords] = useState([]);
    const [editingRecordId, setEditingRecordId] = useState(null);
    const [editedRecord, setEditedRecord] = useState({});

    const org_id = useSelector((state) => state?.account?.org?.id || state?.account?.org_data?.data?.id);
    const user_email = useSelector((state) => state?.account?.user?.email);

    // Fetch records for the specific user
    const fetchRecords = async () => {
        try {
            const response = await axiosInstance.get(`${configData.API_SERVER}/records/get_user_records/?org_id=${org_id}&user_email=${user_email}`);
            setRecords(response.data.records);
        } catch (error) {
            console.error("Error fetching records:", error);
        }
    };

    useEffect(() => {
        fetchRecords();
    }, []);

    // Handle Edit Click
    const handleEdit = (record) => {
        setEditingRecordId(record.id);
        setEditedRecord(record);
    };

    // Handle Input Change
    const handleInputChange = (event, field) => {
        setEditedRecord({ ...editedRecord, [field]: event.target.value });
    };

    // Save Edited Record
    const handleSave = async () => {
        try {
            await axiosInstance.post(`${configData.API_SERVER}/records/update_record/`, { ...editedRecord, org_id, user_email });
            alert("Record updated successfully.");
            setEditingRecordId(null);
            fetchRecords();
        } catch (error) {
            console.error("Error updating record:", error);
            alert("Error updating record.");
        }
    };

    // Cancel Edit
    const handleCancel = () => {
        setEditingRecordId(null);
        setEditedRecord({});
    };

    // Delete Record
    const handleDelete = async (recordId) => {
        if (window.confirm("Are you sure you want to delete this record?")) {
            try {
                await axiosInstance.post(`${configData.API_SERVER}/records/delete_record/`, { record_id: recordId, org_id });
                alert("Record deleted successfully.");
                fetchRecords();
            } catch (error) {
                console.error("Error deleting record:", error);
                alert("Error deleting record.");
            }
        }
    };

    return (
        <MainCard title="Manage Records">
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Value</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {records.length > 0 ? (
                            records.map((record) => (
                                <TableRow key={record.id}>
                                    <TableCell>{record.id}</TableCell>
                                    <TableCell>
                                        {editingRecordId === record.id ? (
                                            <TextField
                                                value={editedRecord.name}
                                                onChange={(event) => handleInputChange(event, "name")}
                                            />
                                        ) : (
                                            record.name
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        {editingRecordId === record.id ? (
                                            <TextField
                                                value={editedRecord.value}
                                                onChange={(event) => handleInputChange(event, "value")}
                                            />
                                        ) : (
                                            record.value
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        {editingRecordId === record.id ? (
                                            <>
                                                <IconButton onClick={handleSave} color="success">
                                                    <SaveIcon />
                                                </IconButton>
                                                <IconButton onClick={handleCancel} color="warning">
                                                    <CloseIcon />
                                                </IconButton>
                                            </>
                                        ) : (
                                            <>
                                                <IconButton onClick={() => handleEdit(record)} color="primary">
                                                    <EditIcon />
                                                </IconButton>
                                                <IconButton onClick={() => handleDelete(record.id)} color="error">
                                                    <DeleteIcon />
                                                </IconButton>
                                            </>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={4} align="center">
                                    No records found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </MainCard>
    );
}

export default ManageRecords;
